import { EventActivityStatusUserMap } from "./types";

export interface IEventActivityStatusDocData {
  status: string;
  label: string;
  eventId: string;
  userId: string;
}

export const processEventActivityStatusMap = (
  firebaseDocData: IEventActivityStatusDocData[],
): EventActivityStatusUserMap =>
  firebaseDocData.reduce(
    (map, eventData) => ({
      ...map,
      [eventData.userId]: {
        status: eventData.status,
        label: eventData.label,
      },
    }),
    {},
  );
